var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSort48Line = function SvgIconSort48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 37.7c-.79 0-1.56-.33-2.1-.91l-4.8-5.06c-.8-.84-1.02-2.08-.56-3.14.46-1.07 1.5-1.75 2.66-1.75h9.6c1.16 0 2.21.69 2.66 1.75.45 1.06.24 2.3-.56 3.14l-4.8 5.06c-.55.58-1.31.9-2.1.9v.01Zm-3.63-7.46L24 34.07l3.64-3.83h-7.27ZM28.8 21.16h-9.6c-1.16 0-2.21-.69-2.66-1.75-.46-1.07-.24-2.3.56-3.14l4.8-5.06c.54-.57 1.31-.9 2.1-.9s1.56.33 2.1.9l4.8 5.06c.8.84 1.02 2.08.56 3.14a2.899 2.899 0 0 1-2.66 1.75Zm-8.43-3.4h7.27L24 13.93l-3.63 3.83Z",
    fill: "current"
  })));
};
export default SvgIconSort48Line;